import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireObject }from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs';

@Injectable()
export class UserdataService {

  userRef: AngularFireObject<any>;
  userSecureRef: AngularFireObject<any>;
  user: Observable<any>;
  userSecure: Observable<any>;
  userId: string;

  constructor(private db: AngularFireDatabase, private afAuth: AngularFireAuth) {

    this.afAuth.authState.subscribe(user => {
      if(user) {
        this.userId = user.uid
        
        this.userRef = db.object(`/users/${this.userId}`);
        this.user = this.userRef.valueChanges();

        this.userSecureRef = db.object(`/usersSecure/${this.userId}`);
        this.userSecure = this.userRef.valueChanges();
      }
    })

  }

  getUserId() {
    return this.userId
  }
  
  getData() { 
    return this.userRef.valueChanges();;
  }

  getSecureData() {
    return this.userSecureRef.valueChanges();
  }

  saveData(userData){
    console.log("Firebase save data:", userData)
    this.userRef.update(userData)
  }

  saveUserLoginData(data){
    // used when a user signs up or logs in
    // create the references
    this.userRef = this.db.object(`/users/${data.user.uid}`);


    // if is new user, log time created at
    if(data.additionalUserInfo.isNewUser) {

      let objToSave = {
        email: data.user.email,
        avatar_url: data.additionalUserInfo.profile.avatar_url,
        bio: data.additionalUserInfo.profile.bio,
        blog: data.additionalUserInfo.profile.blog,
        location: data.additionalUserInfo.profile.location,
        login: data.additionalUserInfo.profile.login,
        name: data.additionalUserInfo.profile.name,
        url: data.additionalUserInfo.profile.url,
        token: data.credential.accessToken,
        portfolio: {
          'projects': [],
          'theme': "angled"
        },
        social: {
          "twitter": "",
          "linkedin": ""
        },
        subscription: null,
        'profileCreated': new Date()
      };

      console.log('objToSave:', objToSave);

      this.userRef.update(objToSave);

    } 

    this.userRef.update({'lastLogin': new Date() })
  }

  // saveInStorage(){

  //   // this.userRef.set({ portfolioData: this.portfolioData});

  // }

  // getFromStorage(){

  //   // return this.portfolioData;

  // }


  // saveData(data){

  //   console.log('saving data:', data);

  //   let uid = data.user.uid

  //   // save user object using user email as key
  //   this.userRef.set( { uid: data })

  // 	return true
  // }

  // setUserRepos(repos){
  //   this.portfolioData.githubRepos = repos;
  //   // console.log("set user repos, portfolioData is now:", this.portfolioData);

  //   // save it
  //   this.saveInStorage();
  //   return true
  // }

  // getUserRepos(){
  //   if(!this.portfolioData.githubRepos || !this.portfolioData.githubRepos.length){
  //     return this.getFromStorage()['githubRepos']
  //   } else {
  //     return this.portfolioData.githubRepos
  //   }
  // }

}



// WEBPACK FOOTER //
// ./src/app/services/userdata.service.ts